import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWhom() {
  return <section className="py-12 bg-brand-cream" data-id="element-49">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-50">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-51">
          {/* For You */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-brand-green" data-id="element-52">
            <h3 className="font-heading text-2xl font-bold text-brand-dark mb-6 flex items-center gap-2" data-id="element-53">
              <CheckCircle2 className="text-brand-green" data-id="element-54" />
              Esto es para ti si...
            </h3>
            <ul className="space-y-3" data-id="element-55">
              {['Cobras quincenal o biweekly', 'Odias presupuestar pero quieres orden', 'Buscas algo simple y práctico', 'Tienes deudas y quieres avanzar', 'Ganas poco o medio', 'Quieres claridad rápida'].map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-text/80" data-id="element-56">
                  <span className="w-1.5 h-1.5 bg-brand-green rounded-full mt-2 flex-shrink-0" data-id="element-57"></span>
                  {item}
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-gray-300" data-id="element-58">
            <h3 className="font-heading text-2xl font-bold text-brand-text mb-6 flex items-center gap-2" data-id="element-59">
              <XCircle className="text-gray-400" data-id="element-60" />
              No es para ti si...
            </h3>
            <ul className="space-y-3" data-id="element-61">
              {['Buscas fórmulas mágicas para hacerte rico', 'Quieres Excel complicado', 'No estás lista para cambios pequeños', 'Esperas resultados sin hacer nada'].map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-text/60" data-id="element-62">
                  <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mt-2 flex-shrink-0" data-id="element-63"></span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}